import React, { Component } from "react";
import { Accordion } from "./components/setting-accordion";
import { SaveButton } from "./components/save-button";
import Icon from "../../../../../../images/settings-icons/setting-food.png";
import styled from "styled-components";
import { modifyUser } from "../../../../../../api";

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;
class UpdateDietRestrictions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dietRestrictions: null,
      expanded: false,
      disableSubmit: true,
      isSubmitting: false,
      show: false,
    };
  }

  handlePanelChange = (event, expanded) => {
    this.setState({ expanded: expanded });
  };

  restrictionsAsString = (restrictions) => {
    let result = "";
    if (restrictions.has("vegan")) {
      result += ", Vegan";
    }
    if (restrictions.has("vegetarian")) {
      result += ", Vegetarian";
    }
    if (restrictions.has("gluten free")) {
      result += ", Gluten Free";
    }
    if (restrictions.has("dairy free")) {
      result += ", Dairy Free";
    }
    if (result) {
      result = result.slice(2);
    } else {
      result = "None";
    }
    return result;
  };

  handleRestriction = (val) => {
    const dietRestrictions =
      this.state.dietRestrictions !== null
        ? this.state.dietRestrictions
        : this.props.dietRestrictions;
    const restrictions = new Set(dietRestrictions);

    if (restrictions.has(val)) {
      restrictions.delete(val);
    } else {
      restrictions.add(val);
    }

    switch (val) {
      case "vegan":
        restrictions.delete("vegetarian");
        restrictions.delete("dairy free");
        break;

      case "vegetarian":
      case "dairy free":
        restrictions.delete("vegan");
        break;

      case "none":
        restrictions.clear();
        break;

      default:
    }

    const disableSubmit =
      this.restrictionsAsString(restrictions) ===
      this.restrictionsAsString(this.props.dietRestrictions);

    this.setState({
      dietRestrictions: restrictions,
      disableSubmit: disableSubmit,
    });
  };

  handleSubmit = () => {
    const dietRestrictions =
      this.state.dietRestrictions !== null
        ? this.state.dietRestrictions
        : this.props.dietRestrictions;
    const vegan = dietRestrictions.has("vegan") ? 1 : 0;
    this.setState({ isSubmitting: true });

    modifyUser(this.props.userId, this.props.portalId, {
      vegetarian: vegan,
      diet_restrictions: [...dietRestrictions],
    }).then((res) => { 
      setTimeout(() => {
        this.props.loadPortalAccount();
        this.setState({ isSubmitting: false, disableSubmit: true });
        this.props.openSnackbar('Setting has been updated', false);
      }, 1000);
    }).catch((err) => {
      setTimeout(() => {
        this.setState({ isSubmitting: false });
        this.props.openSnackbar('Setting failed to update', true);
      }, 1000);
    });
    // this.props
    //   .modifyUser(this.props.userId, {
    //     vegetarian: vegan,
    //     diet_restrictions: [...dietRestrictions],
    //   })
    //   .then(() => {
    //     this.setState({
    //       expanded: false,
    //       disableSubmit: true,
    //       isSubmitting: false,
    //       show: false,
    //     });
    //     this.props.openFeedback(
    //       "Food restrictions have been updated successfully",
    //       false
    //     );
    //   })
    //   .catch((err) => {
    //     this.setState({
    //       expanded: false,
    //       isSubmitting: false,
    //     });
    //     this.props.openFeedback("Unable to update food restrictions", true);
    //   });
  };

  render() {
    const dietRestrictions =
      this.state.dietRestrictions !== null
        ? this.state.dietRestrictions
        : this.props.dietRestrictions;
    return (
      <>
        <Accordion
          show={this.state.show}
          setShow={(val) => this.setState({show: val})}  
          icon={Icon}
          settingName="Food restrictions"
          currentSetting={this.restrictionsAsString(this.props.dietRestrictions)}
          description="Update this user's food restrictions"
          roundTop
        >
          <>
            {/* <Input onChange={(e) => setName(e.target.value)} value={name} /> */}
            <div className="preferences-diet-restrictions-button-container">
              <button
                className={
                  dietRestrictions.size === 0
                    ? "preferences-diet-restrictions-button active"
                    : "preferences-diet-restrictions-button"
                }
                onClick={() => this.handleRestriction("none")}
              >
                None
              </button>
              <button
                className={
                  dietRestrictions.has("vegan")
                    ? "preferences-diet-restrictions-button active"
                    : "preferences-diet-restrictions-button"
                }
                onClick={() => this.handleRestriction("vegan")}
              >
                Vegan
              </button>
              <button
                className={
                  dietRestrictions.has("vegetarian")
                    ? "preferences-diet-restrictions-button active"
                    : "preferences-diet-restrictions-button"
                }
                onClick={() => this.handleRestriction("vegetarian")}
              >
                Vegetarian
              </button>
              <button
                className={
                  dietRestrictions.has("gluten free")
                    ? "preferences-diet-restrictions-button active"
                    : "preferences-diet-restrictions-button"
                }
                onClick={() => this.handleRestriction("gluten free")}
              >
                Gluten Free
              </button>
              <button
                className={
                  dietRestrictions.has("dairy free")
                    ? "preferences-diet-restrictions-button active"
                    : "preferences-diet-restrictions-button"
                }
                onClick={() => this.handleRestriction("dairy free")}
              >
                Dairy Free
              </button>
            </div>
            <ButtonRow>
              <SaveButton
                disabled={this.state.disableSubmit}
                isLoading={this.state.isSubmitting}
                onClick={this.handleSubmit}
              />
            </ButtonRow>
          </>
        </Accordion>
      </>
    );
  }
}

// function mapStateToProps(state) {
//   const dietRestrictions =
//     state.user.diet_restrictions !== null &&
//     state.user.diet_restrictions !== undefined
//       ? new Set(state.user.diet_restrictions)
//       : new Set();
//   return {
//     userId: state.user.id,
//     dietRestrictions: dietRestrictions,
//   };
//   return {
//     userId: state.user.id,
//     dietRestrictions: new Set(['vegan']),
//   };
// }

// function mapDispatchToProps(dispatch) {
//   return bindActionCreators({ modifyUser, openFeedback }, dispatch);
// }

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(UpdateDietRestrictions);

export default UpdateDietRestrictions;
